import { useColors } from "../../../../hooks/useColors";

export function IndeterminateIcon() {
  const colors = useColors();

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill={colors["icon-inverse"]}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 9C4 8.44772 4.44772 8 5 8H13C13.5523 8 14 8.44772 14 9C14 9.55228 13.5523 10 13 10H5C4.44772 10 4 9.55228 4 9Z" />
    </svg>
  );
}
